import { render, staticRenderFns } from "./SalesorderitemReg.vue?vue&type=template&id=3d53952f&"
import script from "./SalesorderitemReg.vue?vue&type=script&lang=js&"
export * from "./SalesorderitemReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports